(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ecomgomar-hide-cart"]) return;
  try {
    
  (() => {
    const checkoutByPage = {
      '/pages/llamada-estrategica-ecommerce': '58586439254361',
      '/pages/auditoria-express-ecommerce': '58586438795609',
      '/pages/deep-dive-ecommerce': '58586439647577',
      '/pages/bono-4-llamadas-ecommerce': '58586450461017',
      '/pages/bono-8-llamadas-ecommerce': '58586453082457',
      '/pages/advisory-mensual-ecommerce': '58586453737817',
      '/pages/advisory-trimestral-ecommerce': '58597724914009',
      '/pages/advisory-semestral-ecommerce': '58597724946777',
    };

    const checkoutByVariant = Object.values(checkoutByPage).reduce((links, variantId) => {
      links[variantId] = `/cart/add?id=${variantId}&quantity=1&return_to=%2Fcheckout`;
      return links;
    }, {});

    const payWords = ['pagar', 'reservar'];

    function variantFromLink(anchor) {
      const href = anchor.getAttribute('href') || '';
      const matchedVariant = Object.keys(checkoutByVariant).find((variantId) => href.includes(variantId));

      if (matchedVariant) return matchedVariant;

      const path = window.location.pathname.replace(/\/$/, '');
      const text = anchor.textContent.trim().toLowerCase();
      const isPayButton = payWords.some((word) => text.includes(word));

      if (isPayButton && checkoutByPage[path]) return checkoutByPage[path];

      return null;
    }

    function prepareCheckoutLinks() {
      document.querySelectorAll('.eg-cta a[href="/collections/consultorias-1-1"]').forEach((ctaLink) => {
        ctaLink.href = '/#planes';
        ctaLink.textContent = 'Ver planes y reservar';
      });

      document.querySelectorAll('a[href^="/pages/"]').forEach((detailLink) => {
        const href = detailLink.getAttribute('href').replace(/\/$/, '');
        const variantId = checkoutByPage[href];

        if (!variantId || detailLink.closest('.eg-card-actions') || detailLink.dataset.ecomgomarWrapped === 'true') return;

        const actions = document.createElement('div');
        const payLink = document.createElement('a');

        actions.className = 'eg-card-actions';
        payLink.className = 'eg-card-pay';
        payLink.href = checkoutByVariant[variantId];
        payLink.textContent = 'Pagar ahora';
        detailLink.classList.add('eg-card-detail');
        detailLink.dataset.ecomgomarWrapped = 'true';

        detailLink.parentNode.insertBefore(actions, detailLink);
        actions.appendChild(payLink);
        actions.appendChild(detailLink);
      });

      document.querySelectorAll('a').forEach((anchor) => {
        const variantId = variantFromLink(anchor);
        if (!variantId || anchor.dataset.ecomgomarCheckoutReady === 'true') return;

        anchor.href = checkoutByVariant[variantId];
        anchor.dataset.ecomgomarCheckoutReady = 'true';
      });
    }

    document.addEventListener('DOMContentLoaded', prepareCheckoutLinks);
    prepareCheckoutLinks();
    new MutationObserver(prepareCheckoutLinks).observe(document.documentElement, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.mobile-menu').forEach((menu) => {
    const closeButton = menu.querySelector('.mobile-menu__close');
    const links = menu.querySelectorAll('a');

    const closeMenu = () => {
      menu.removeAttribute('open');
    };

    closeButton?.addEventListener('click', closeMenu);
    links.forEach((link) => link.addEventListener('click', closeMenu));

    menu.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenu();
        menu.querySelector('summary')?.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
